import { Optional } from '../../../types.js';
import { RenderGroup } from './types.js';
export const getRenderGroupsMinMaxValue = (groups: RenderGroup[]) => {
  const values = groups.reduce<{
    minValue: Optional<number>;
    maxValue: Optional<number>;
  }>((acc, current) => {
    if (Number.isFinite(current.minValue)) {
      acc.minValue = Number.isFinite(acc.minValue) && Number(acc.minValue) < Number(current.minValue) ? acc.minValue : current.minValue;
    }
    if (Number.isFinite(current.maxValue)) {
      acc.maxValue = Number.isFinite(acc.maxValue) && Number(acc.maxValue) > Number(current.maxValue) ? acc.maxValue : current.maxValue;
    }
    return acc;
  }, {
    minValue: undefined,
    maxValue: undefined
  });
  ensureDefinedMinMaxValues(values);
  ensureMinMaxAdhereToDomainOfZero(values); // skip if we don't want to lock value range to domain of zero

  return {
    minValue: Number(values.minValue),
    maxValue: Number(values.maxValue)
  };
};
const ensureDefinedMinMaxValues = (values: {
  minValue: Optional<number>;
  maxValue: Optional<number>;
}) => {
  if (!Number.isFinite(values.minValue)) {
    values.minValue = 0;
  }
  if (!Number.isFinite(values.maxValue)) {
    values.maxValue = 0;
  }
};
const ensureMinMaxAdhereToDomainOfZero = (values: {
  minValue: Optional<number>;
  maxValue: Optional<number>;
}) => {
  if (Number(values.minValue) > 0) {
    values.minValue = 0;
  }
  if (Number(values.maxValue) < 0) {
    values.maxValue = 0;
  }
};